module.exports = __webpack_public_path__ + "img/1990_L.aa47d738.png";